import { Cookies } from "react-cookie";

export function getAuthUser<T = Record<string, any>>(): T | null {
  const cookies = new Cookies();
  return cookies.get("LoveStrongUser") || null;
}

export function useAuthUser<T = Record<string, any>>(): T | null {
  return getAuthUser<T>();
}
